// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, maybe, enumOf } from "@altostra/type-validations";
import { boolean, number, string, any } from "@altostra/type-validations/lib/primitives";

const testUserLogEvent = objectOf({
  event_name: string,
  event_description: string,
  tooltip: maybe(string),
  campaign_ids: maybe(arrayOf(string)),
});

const respondWith = objectOf({
  triggers: boolean,
  in_app_message: objectOf({ count: number }),
  config: objectOf({ config_time: number }),
  feed: any,
});

export const isAppSettingsTestUserLogsResult = objectOf({
  hits: number,
  results: arrayOf(
    objectOf({
      type: enumOf("SdkTestUserLogEntry", "RestTestUserLogEntry"),
      tu_id: string,
      requested_at: number,
      external_user_id: string,
      events: arrayOf(testUserLogEvent),
      purchases: arrayOf(any),
      attributes: any,
      device_hash: maybe(
        objectOf({
          Browser: maybe(string),
          "Browser Version": maybe(string),
          "User Agent": maybe(string),
          "Device Carrier": maybe(string),
          "Device Locale": maybe(string),
          "Device Model": maybe(string),
          "OS Version": maybe(string),
          "iOS Push Auth": maybe(string),
          "": maybe(string),
          "Foreground Push Enabled": maybe(string),
          "Screen Resolution": maybe(string),
          "Device Time Zone": maybe(string),
        })
      ),
      a_id: maybe(string),
      sdk_version: maybe(string, true),
      device_id: maybe(string),
      id: string,
      raw_event_hash: maybe(arrayOf(any), true),
      raw_purchase_hash: maybe(any),
      raw_device_hash: maybe(
        objectOf({
          ios_push_auth: maybe(string),
          ios_push_display_options: maybe(
            objectOf({
              ios_alert: maybe(enumOf("enabled", "disabled", "not_supported")),
              ios_announcement: maybe(enumOf("enabled", "disabled", "not_supported")),
              ios_badge: maybe(enumOf("enabled", "disabled", "not_supported")),
              ios_car_play: maybe(enumOf("enabled", "disabled", "not_supported")),
              ios_critical_alert: maybe(enumOf("enabled", "disabled", "not_supported")),
              ios_lock_screen: maybe(enumOf("enabled", "disabled", "not_supported")),
              ios_notification_center: maybe(enumOf("enabled", "disabled", "not_supported")),
              ios_sound: maybe(enumOf("enabled", "disabled", "not_supported")),
            })
          ),
          remote_notification_enabled: maybe(boolean),
          browser: maybe(string),
          browser_version: maybe(string),
          user_agent: maybe(string),
          carrier: maybe(string),
          locale: maybe(string),
          model: maybe(string),
          os_version: maybe(string),
          resolution: maybe(string),
          time_zone: maybe(string),
        })
      ),
      response_hash: maybe(any),
      app_group_id: maybe(string),
      sdk_time: maybe(string),
      app_name: maybe(string),
      app_type: maybe(string),
      test_username: maybe(string),
      respond_with: maybe(respondWith, true),
    })
  ),
});
